export const CURRENT_YEAR = new Date().getFullYear();

export const PROVIDER_LABELS = {
  paypal: "PayPal",
  stripe: "Stripe",
  stripe_sepa: "SEPA",
  virement: "Virement",
  especes: "Espèces",
  cheque: "Chèque",
  stripe_link: "Lien Stripe",
};

// Moyens de paiement que l'admin peut saisir manuellement pour un paiement déjà reçu.
export const ADMIN_RECORDABLE_PROVIDERS = [
  { value: "especes", label: "Espèces" },
  { value: "virement", label: "Virement" },
  { value: "cheque", label: "Chèque" },
];

export const AGE_BRACKETS = [
  { label: "80+",   min: 80,  max: 150 },
  { label: "75–79", min: 75,  max: 79  },
  { label: "70–74", min: 70,  max: 74  },
  { label: "65–69", min: 65,  max: 69  },
  { label: "60–64", min: 60,  max: 64  },
  { label: "55–59", min: 55,  max: 59  },
  { label: "50–54", min: 50,  max: 54  },
  { label: "45–49", min: 45,  max: 49  },
  { label: "40–44", min: 40,  max: 44  },
  { label: "35–39", min: 35,  max: 39  },
  { label: "30–34", min: 30,  max: 34  },
  { label: "25–29", min: 25,  max: 29  },
  { label: "20–24", min: 20,  max: 24  },
  { label: "15–19", min: 15,  max: 19  },
  { label: "10–14", min: 10,  max: 14  },
  { label:  "5–9",  min:  5,  max:  9  },
  { label:  "0–4",  min:  0,  max:  4  },
];

export const getAge = (birthDate) => {
  if (!birthDate) return null;
  // Handle DD/MM/YYYY (French format)
  let normalized = birthDate;
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(birthDate)) {
    const [d, m, y] = birthDate.split("/");
    normalized = `${y}-${m}-${d}`;
  }
  const date = new Date(normalized);
  if (isNaN(date.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - date.getFullYear();
  const monthDiff = today.getMonth() - date.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) age--;
  return age;
};

export const formatEur = (n, opts = {}) =>
  `${Number(n ?? 0).toLocaleString("fr-FR", opts)} €`;

export const fadeUpCss = `
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .fade-up { animation: fadeUp 0.5s ease both; }
  .fade-up-1 { animation-delay: 0.05s; }
  .fade-up-2 { animation-delay: 0.12s; }
  .fade-up-3 { animation-delay: 0.20s; }
  .fade-up-4 { animation-delay: 0.28s; }
  .fade-up-5 { animation-delay: 0.36s; }
`;
